export const PRICE_SCALE = 100;

export const TRADING_VIEW_SYMBOL_EDIT_FILTER = 'tradingview.symboledit.filter';
export const TRADING_VIEW_HIDE_LEFT_TOOLBAR =
  'tradingview.ChartDrawingToolbarWidget.visible';

export const supportedResolutions = [
  '1',
  '5',
  '15',
  '30',
  '60',
  '120',
  '240',
  'D',
  'W',
  'M',
  '3M',
  '12M',
];

export const guestResolutions = ['D', 'W', 'M', '3M', '12M'];

export const MAX_ITEM_LENGTH = 100;

export const EXCHANGES = {
  ALL: 'All',
  HSX: 'HSX',
  HNX: 'HNX',
  UPCOM: 'UPCOM',
};

export const MAP_EXCHANGES = {
  HSX: ['VNINDEX'],
  HNX: ['HNXIndex'],
  UPCOM: ['UpcomIndex'],
};

export const SYMBOL_TYPES = {
  ALL: 'All',
  STOCK: 'Stock',
  FUTURES: 'Futures', //Derivative
  INDICES: 'Indices', //index
  ECONOMY: 'Economy',
  COVERED_WARRANT: 'CW',
  SECTOR: 'Sector',
};

export const config = {
  supported_resolutions: supportedResolutions,
  exchanges: [
    { value: EXCHANGES.ALL, name: 'All Exchanges' },
    { value: EXCHANGES.HSX, name: 'HSX' },
    { value: EXCHANGES.HNX, name: 'HNX' },
    { value: EXCHANGES.UPCOM, name: 'UPCOM' },
  ],
  supports_group_request: false,
  supports_marks: true,
  supports_search: true,
  supports_time: true,
  supports_timescale_marks: true,
  symbols_types: [
    { name: 'All', value: SYMBOL_TYPES.ALL },
    { name: 'Stock', value: SYMBOL_TYPES.STOCK },
    { name: 'Futures', value: SYMBOL_TYPES.FUTURES },
    { name: 'Indices', value: SYMBOL_TYPES.INDICES },
    { name: 'Economy', value: SYMBOL_TYPES.ECONOMY },
    { name: 'Covered Warrant', value: SYMBOL_TYPES.COVERED_WARRANT },
    { name: 'Sector', value: SYMBOL_TYPES.SECTOR },
  ],
};

export const UNITS = {
  THOUSAND: 'thousand',
  MILLION: 'million',
  BILLION: 'billion',
  TRILLION: 'trillion',
  PERCENT: 'percent',
};

export const ECONOMY_FORMAT_UNIT_BY_CODE = {
  CEMENTPRICE: '',
  CPI_MoM: UNITS.PERCENT,
  CPI_RTD: UNITS.PERCENT,
  CPI_YoY: UNITS.PERCENT,
  D_VND_12MMax: UNITS.PERCENT,
  DisbursedCap: UNITS.BILLION,
  DJI: '',
  Exports_ValM: UNITS.BILLION,
  GDP_PPP: UNITS.TRILLION,
  GDP_YoY: UNITS.PERCENT,
  GoldS: '',
  IIP_MoM: UNITS.PERCENT,
  IIP_YoY: UNITS.PERCENT,
  Imports_ValM: UNITS.BILLION,
  Last10Y: UNITS.PERCENT,
  Last5Y: UNITS.PERCENT,
  Liquidity: UNITS.TRILLION,
  Liquidity_MoM: UNITS.PERCENT,
  Liquidity_YoY: UNITS.PERCENT,
  Liquidity_YTD: UNITS.PERCENT,
  N225: '',
  NASDAQ: '',
  OilWTI: '',
  OV_R: UNITS.PERCENT,
  OV_V: UNITS.TRILLION,
  PEHNX: '',
  PEHOSE: '',
  PEUPCOM: '',
  PMI: '',
  PMI_Change: '',
  PMI_MoM: UNITS.PERCENT,
  PMIF: '',
  RegdCap: UNITS.BILLION,
  STEELPRICESB: '',
  STEELPRICESWR: '',
  USD_VND: '',
};

export const icbCodeToTicker = {
  '0500': 'OILGAS_L2',
  '1300': 'CHEMICAL_L2',
  '1700': 'BASICRES_L2',
  '2300': 'CONSTRMAT_L2',
  '2700': 'INDUSTGDS_L2',
  '3300': 'AUTOPARTS_L2',
  '3500': 'FOODBEVERA_L2',
  '3700': 'PERSHHOLD_L2',
  '4500': 'HEALTHCARE_L2',
  '5300': 'RETAIL_L2',
  '5500': 'MEDIA_L2',
  '5700': 'TRAVELLSR_L2',
  '6500': 'TELECOM_L2',
  '7500': 'UTILITIES_L2',
  '8300': 'BANKS_L2',
  '8500': 'INSURANCE_L2',
  '8600': 'REALESTATE_L2',
  '8700': 'FINSERV_L2',
  '9500': 'TECHNOLOGY_L2',
  '0533': 'EXPLPROD_L4',
  '0537': 'INTEGRATED_L4',
  '0573': 'OILEQUIPME_L4',
  '0577': 'PIPELINES_L4',
  '0583': 'RENEWEQP_L4',
  '0587': 'ALTFUELS_L4',
  '1353': 'COMMDCHEM_L4',
  '1357': 'SPECCHEM_L4',
  '1733': 'FORESTRY_L4',
  '1737': 'PAPER_L4',
  '1753': 'ALUMINUM_L4',
  '1755': 'NONFERROUS_L4',
  '1757': 'STEEL_L4',
  '1771': 'COAL_L4',
  '1773': 'DIAMONDSGE_L4',
  '1775': 'GENERALMIN_L4',
  '1777': 'GOLDMINING_L4',
  '1779': 'PLATINUMPR_L4',
  '2353': 'BUILDINGMA_L4',
  '2357': 'HEAVYCONST_L4',
  '2713': 'AEROSPACE_L4',
  '2717': 'DEFENSE_L4',
  '2723': 'CONTAINERS_L4',
  '2727': 'DIVERSIFIE_L4',
  '2733': 'ELECTRICAL_L4',
  '2737': 'ELECTRONIC_L4',
  '2753': 'COMMERCIAL_L4',
  '2757': 'INDUSTRIALM_L4',
  '2771': 'DELIVERYSE_L4',
  '2773': 'MARINETRAN_L4',
  '2775': 'RAILROADS_L4',
  '2777': 'TRANSPORTA_L4',
  '2779': 'TRUCKING_L4',
  '2791': 'BUSINESSSU_L4',
  '2793': 'BUSINESSTR_L4',
  '2795': 'FINANCIALA_L4',
  '2797': 'INDUSTRIALS_L4',
  '2799': 'WASTEDISPO_L4',
  '3353': 'AUTOMOBILE_L4',
  '3355': 'AUTOPARTS_L4',
  '3357': 'TIRES_L4',
  '3533': 'BREWERS_L4',
  '3535': 'DISTILLERS_L4',
  '3537': 'SOFTDRINKS_L4',
  '3573': 'FARMINGFIS_L4',
  '3577': 'FOODPRODUC_L4',
  '3722': 'DURABLEHOU_L4',
  '3724': 'NONDURABLE_L4',
  '3726': 'FURNISHING_L4',
  '3728': 'HOMECONSTR_L4',
  '3743': 'CONSUMEREL_L4',
  '3745': 'RECREPRODUCT_L4',
  '3747': 'TOYS_L4',
  '3763': 'CLOTHACC_L4',
  '3765': 'FOOTWEAR_L4',
  '3767': 'PERSONALPR_L4',
  '3785': 'TOBACCO_L4',
  '4533': 'HEALTHCARE_L4',
  '4535': 'MEDEQUIP_L4',
  '4537': 'MEDSUPPL_L4',
  '4573': 'BIOTECHNOL_L4',
  '4577': 'PHARMACEUT_L4',
  '5333': 'DRUGRETAIL_L4',
  '5337': 'FOODRETAIL_L4',
  '5371': 'CLOTHRETAIL_L4',
  '5373': 'BROADRETAIL_L4',
  '5375': 'HOMEIMPROV_L4',
  '5377': 'SPECIALIZE_L4',
  '5379': 'SPECIALTYR_L4',
  '5553': 'BROADCASTI_L4',
  '5555': 'MEDIAAGENC_L4',
  '5557': 'PUBLISHING_L4',
  '5751': 'AIRLINES_L4',
  '5752': 'GAMBLING_L4',
  '5753': 'HOTELS_L4',
  '5755': 'RECRESERVICES_L4',
  '5757': 'RESTAURANT_L4',
  '5759': 'TRAVELTOUR_L4',
  '6535': 'FIXEDLINET_L4',
  '6575': 'MOBILETELE_L4',
  '7535': 'CONVENTION_L4',
  '7573': 'GASDISTRIB_L4',
  '7575': 'MULTIUTILI_L4',
  '7577': 'WATER_L4',
  '8355': 'BANKS_L4',
  '8532': 'FULLINSU_L4',
  '8534': 'INSUBROKER_L4',
  '8536': 'NONLIFEINSU_L4',
  '8538': 'REINSURANC_L4',
  '8575': 'LIFEINSU_L4',
  '8633': 'REALESTATE_L4',
  '8637': 'RESERVICES_L4',
  '8677': 'REINVEST_L4',
  '8771': 'ASSETMANAG_L4',
  '8773': 'CONSUMFINAN_L4',
  '8775': 'SPECFINAN_L4',
  '8777': 'INVESTMENT_L4',
  '8779': 'MORTGAGEFI_L4',
  '8985': 'EQUITYINVE_L4',
  '9533': 'COMPUTERSE_L4',
  '9535': 'INTERNET_L4',
  '9537': 'SOFTWARE_L4',
  '9572': 'COMPHARDW_L4',
  '9574': 'ELECOFFEQ_L4',
  '9576': 'SEMICONDUC_L4',
  '9578': 'TELECOMEQU_L4',
};

export const icbTickerToCode = Object.keys(icbCodeToTicker).reduce(
  (obj, code) => ({ ...obj, [icbCodeToTicker[code]]: code }),
  {},
);
